import { useEffect } from 'react';
import React from 'react';
import AOS from 'aos';
import picAbout from '../Assets/HomePage/soc.png';
import picComp from '../Assets/HomePage/COMPETITIONS.webp';
import picRegistration from '../Assets/HomePage/2023_0216_08144200.webp';
import picScoreboard from '../Assets/HomePage/SCOREBOARD.webp';
import picSoundscape from '../Assets/HomePage/SOUNDSCAPE.webp';
import { Link } from 'react-router-dom';

export default function Button() {
        
    useEffect(() => {
        // Inisialisasi AOS
        const AOS = require("aos");
        AOS.init({
          once: true,
        });
      }, []);
    
    useEffect(() => {
        if (AOS) {
          AOS.refresh();
        }
      });

    return(
        // Penyesuaian padding vertikal atas dan bawah agar lebih seimbang di mobile dan desktop
        <div className='overflow-hidden py-16 lg:py-24 mt-[50px] lg:mt-[40px]'> 
            {/* CONTAINER UTAMA UNTUK ABOUT SOC */}
            {/* Menggunakan w-11/12 atau w-full di mobile dan membatasi lebar di desktop (max-w-6xl) */}
            <div className='flex flex-col items-center justify-center mx-auto w-11/12 lg:w-3/4 max-w-6xl mb-12 lg:mb-20'>

                {/* JUDUL: Ukuran font disesuaikan (text-4xl di mobile, text-6xl di desktop) */}
                <h2 className='text-4xl lg:text-6xl font-serif text-[#003B73] mb-8 lg:mb-10 font-medium text-center'>
                    About SOC
                </h2>
                
                {/* GAMBAR: Dibuat responsif */}
                <img 
                    src={picAbout}
                    alt="Smakonecup"
                    className="rounded-xl shadow-lg mb-8 lg:mb-12 w-full object-cover"
                    // Menggunakan Tailwind CSS untuk mengatur tinggi dan lebar maksimal
                    style={{ maxHeight: "400px", maxWidth: "800px" }}
                />

                {/* TEKS DESKRIPSI */}
                <div className='w-full max-w-3xl text-justify text-gray-700 leading-relaxed px-2'>
                    <p className='mb-4 text-sm sm:text-base'>
                        Smakonecup atau yang biasa disingkat SOC adalah sebuah acara tahunan yang berisikan lomba-lomba akademik dan non-akademik antar sekolah yang diselenggarakan oleh SMAK 1 PENABUR Jakarta. Acara ini biasanya diadakan di bulan Oktober dan berlangsung selama 10 hari. Smakonecup pertama kali diadakan pada tahun 1995, jadi acara ini sudah dilakukan oleh 26 generasi murid SMAK 1. Dalam acara ini, terdapat lomba akademis seperti lomba Matematika, IPA, dan Bahasa Inggris untuk SMP dan debat bagi SMA. Sedangkan lomba non-akademis berupa lomba olahraga, musik, seni, dan PASKIBRA untuk tingkat SMA.
                    </p>
                </div>
            </div>
            {/* AKHIR CONTAINER UNTUK ABOUT SOC */}

            {/* Bagian Tombol (masih kosong) */}
            <div className='w-3/4 flex flex-col translate-x-[16%]'>
                {/* TEMPAT TOMBOL NAVIGASI */}
            </div>
        </div>
    );
}